import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

// Confirmação das ações sensíveis da gestão de usuários (desativar, trocar perfil, gerar
// link de senha). O foco inicial fica em "Voltar", para um Enter apressado não confirmar.
export default function ConfirmActionDialog({ isOpen, onClose, onConfirm, title, confirmLabel, isLoading, isDestructive, children }) {
  const cancelRef = useRef();
  const destructiveStyle = isDestructive ? { bg: "danger.500", color: "white", _hover: { bg: "danger.600" } } : {};

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>
          <AlertDialogBody>{children}</AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} variant="ghost" onClick={onClose} isDisabled={isLoading}>
              Voltar
            </Button>
            <Button onClick={onConfirm} isLoading={isLoading} {...destructiveStyle}>
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
